import { apiClient, apiClientPublic } from "services/api-client"

export const getUserMetrics = async (slug) => {
  return await apiClient.get(`/user/metrics?slug=${slug}`)
}

export const getUsers = async (
  tenant,
  page,
  perPage,
  typeFilter,
  searchContent,
  active
) => {
  const activeParam = active !== undefined ? `&active=${active}` : ''
  return await apiClient.get(`/user/paged?companyKey=${tenant}&page=${page}&perPage=${perPage}&typeFilter=${typeFilter}&searchContent=${searchContent}${activeParam}`)
}

export const getUsersName = async (tenant) => {
  return await apiClient.get(`/user/names?companyKey=${tenant}`)
}

export const getUsersNameEmailByCompany = async (tenant) => {
  return await apiClient.get(`/user/names-email-by-company?companyKey=${tenant}`)
}

export const getUserById = async (id) => {
  return await apiClient.get(`/user/${id}`)
}

export const addUser = async (data) => {
  return await apiClient.post('/user', data)
}

export const createUser = async (data) => {
  return await apiClientPublic.post('/user/create-user', data)
}

export const createUserOnboarding = async (data) => {
  return await apiClientPublic.post('/user/onboarding', data)
}

export const editUser = async (id, slug, data) => {
  return await apiClient.put(`/user/${id}/${slug}`, data)
}

export const deleteUser = async (id) => {
  return await apiClient.delete(`/user/${id}`)
}

export const enableUser = async (id) => {
  return await apiClient.post(`/user/${id}/enable`)
}

export const validateUserEmail = async (email) => {
  return await apiClientPublic.get(`/user/is-valid-email/${email}`)
}

export const getUsersVerifyCodesPaged = async (tenant, page, perPage, searchContent) => {
  const searchContentParam = searchContent !== '' ? `&searchContent=${searchContent}`: '';
  return await apiClient.get(`/user/verify-codes?companyKey=${tenant}&page=${page}&perPage=${perPage}${searchContentParam}`)
}

export const deleteUserVerifyCode = async (id) => {
  return await apiClient.delete(`/user/verify-code/${id}`)
}

export const updateLanguagePreference = async (language) => {
  return await apiClient.patch('/user/language-preference', { preferredLanguage: language })
}